var _g, _path, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 544,
    height: 245,
    viewBox: "0 0 544 245",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 42.1343V202.134",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6364 42.1343V202.134",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.273 42.1343V202.134",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.909 42.1343V202.134",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.545 42.1343V202.134",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.182 42.1343V202.134",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.818 42.1343V202.134",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.455 42.1343V202.134",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.091 42.1343V202.134",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.727 42.1343V202.134",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.364 42.1343V202.134",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 42.1343V202.134",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 42.1343H512",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 82.1343H512",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 122.134H512",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 162.134H512",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 202.134H512",
    stroke: "white"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 77.1858C38.773 77.1858 42.3699 146.258 49.1429 146.258C55.9159 146.258 59.5127 42.1343 66.2857 42.1343C73.0587 42.1343 76.6556 174.093 83.4286 174.093C90.2016 174.093 93.7984 181.103 100.571 181.103C107.344 181.103 110.941 179.041 117.714 179.041C124.487 179.041 128.084 195.949 134.857 195.949C141.63 195.949 145.227 127.701 152 127.701C158.773 127.701 162.37 154.299 169.143 154.299C175.916 154.299 179.513 165.021 186.286 165.021C193.059 165.021 196.656 133.062 203.429 133.062C210.202 133.062 213.798 120.279 220.571 120.279C227.344 120.279 230.941 100.897 237.714 100.897C244.487 100.897 248.084 107.495 254.857 107.495C261.63 107.495 265.227 148.526 272 148.526C278.773 148.526 282.37 158.835 289.143 158.835C295.916 158.835 299.513 107.083 306.286 107.083C313.059 107.083 316.656 164.196 323.429 164.196C330.202 164.196 333.798 169.969 340.571 169.969C347.344 169.969 350.941 202.134 357.714 202.134C364.487 202.134 368.084 189.145 374.857 189.145C381.63 189.145 385.227 115.743 392 115.743C398.773 115.743 402.37 166.464 409.143 166.464C415.916 166.464 419.513 115.949 426.286 115.949C433.059 115.949 436.656 195.743 443.429 195.743C450.202 195.743 453.798 128.114 460.571 128.114C467.344 128.114 470.941 178.011 477.714 178.011C484.487 178.011 488.084 137.598 494.857 137.598C501.63 137.598 505.227 86.0518 512 86.0518V202.134H32V77.1858Z",
    fill: "url(#paint0_linear_51_4321)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_51_4321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 77.1858C38.773 77.1858 42.3699 146.258 49.1429 146.258C55.9159 146.258 59.5127 42.1343 66.2857 42.1343C73.0587 42.1343 76.6556 174.093 83.4286 174.093C90.2016 174.093 93.7984 181.103 100.571 181.103C107.344 181.103 110.941 179.041 117.714 179.041C124.487 179.041 128.084 195.949 134.857 195.949C141.63 195.949 145.227 127.701 152 127.701C158.773 127.701 162.37 154.299 169.143 154.299C175.916 154.299 179.513 165.021 186.286 165.021C193.059 165.021 196.656 133.062 203.429 133.062C210.202 133.062 213.798 120.279 220.571 120.279C227.344 120.279 230.941 100.897 237.714 100.897C244.487 100.897 248.084 107.495 254.857 107.495C261.63 107.495 265.227 148.526 272 148.526C278.773 148.526 282.37 158.835 289.143 158.835C295.916 158.835 299.513 107.083 306.286 107.083C313.059 107.083 316.656 164.196 323.429 164.196C330.202 164.196 333.798 169.969 340.571 169.969C347.344 169.969 350.941 202.134 357.714 202.134C364.487 202.134 368.084 189.145 374.857 189.145C381.63 189.145 385.227 115.743 392 115.743C398.773 115.743 402.37 166.464 409.143 166.464C415.916 166.464 419.513 115.949 426.286 115.949C433.059 115.949 436.656 195.743 443.429 195.743C450.202 195.743 453.798 128.114 460.571 128.114C467.344 128.114 470.941 178.011 477.714 178.011C484.487 178.011 488.084 137.598 494.857 137.598C501.63 137.598 505.227 86.0518 512 86.0518",
    stroke: "#9FFB00",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_51_4321",
    x: -10,
    y: 0.134277,
    width: 564,
    height: 244,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.623529 0 0 0 0 0.984314 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_51_4321"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_51_4321",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_51_4321",
    x1: 272,
    y1: 42.1343,
    x2: 272,
    y2: 202.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FFB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FFB00",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.f9a5720c0588dc70caf627073ecfd761.svg";
export { ForwardRef as ReactComponent };